var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3RdPartyLicenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31.25,
    width: 28,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 37.25,
    width: 28,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 43.25,
    width: 28,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49.25,
    width: 20,
    height: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61,70.75A9.75,9.75,0,1,0,51.25,61,9.76128,9.76128,0,0,0,61,70.75Zm0-18A8.25,8.25,0,1,1,52.75,61,8.25965,8.25965,0,0,1,61,52.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60,64.75a.74671.74671,0,0,0,.53027-.21973l6-6-1.06054-1.06054L60,62.93945l-2.46973-2.46972-1.06054,1.06054,3,3A.74671.74671,0,0,0,60,64.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75,48V24a.75027.75027,0,0,0-.21973-.53027l-14-14A.74942.74942,0,0,0,46,9.25H20a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75H50v-1.5H20.75V10.75h24.5V24a.7502.7502,0,0,0,.75.75H59.25V48Zm-14-24.75V11.81055L58.18945,23.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3RdPartyLicenses);
export default __webpack_public_path__ + "static/media/icon_3rd_party_licenses.4a3925393780b18b45f3337922ecef16.svg";
export { ForwardRef as ReactComponent };